import { __assign } from "tslib";
//Imports
import * as React from 'react';
import FullCalendar from '@fullcalendar/react'; // must go before plugins
//Components
import WeeklyDatePicker from '../../presentationals/WeeklyDatePicker';
import WeeklyEvent from '../../presentationals/WeeklyEvent';
import WeeklyLeftSideTime from '../../presentationals/WeeklyLeftSideTime';
//Utils
import { dateToMomentWithFormat } from '../../../utils/momentUtils';
import * as utils from '../Calendar/CalendarUtlis/CalendarUtils';
import getFCDesktopOptions from '../../../utils/getFCOptions';
import WixStylesContext from '../../../context/wixStylesContext';
import WeeklyContext from '../../../context/weeklyContext';
var WeeklyCalendarFunc = function () {
    var _a = React.useContext(WixStylesContext), is24format = _a.is24format, isResponsive = _a.isResponsive, isCurrentTimeShown = _a.isCurrentTimeShown;
    var _b = React.useContext(WeeklyContext), timezone = _b.timezone, calendarRef = _b.calendarRef, handleMonthChange = _b.handleMonthChange, rerenderTitleHandler = _b.rerenderTitleHandler, dates = _b.dates, locale = _b.locale, firstDay = _b.firstDay, isPrivateEventsShown = _b.isPrivateEventsShown, 
    // recurrenceArr,
    isMobile = _b.isMobile, datePickerIsShown = _b.datePickerIsShown, setDatePickerIsShown = _b.setDatePickerIsShown;
    var datePickerRef = React.useRef(null);
    var datePickerSelectHandler = function (date) {
        var format = 'YYYY-MM-DD';
        var today = dateToMomentWithFormat(new Date(), format);
        var chosenDate = dateToMomentWithFormat(date, format);
        var isFutureDay = chosenDate > today;
        var _a = utils.getStartAndEndMonthDates(date), start = _a.start, end = _a.end;
        handleMonthChange(start, end, timezone, isFutureDay);
        //@ts-ignore
        calendarRef.current.getApi().gotoDate(date);
        rerenderTitleHandler();
    };
    React.useEffect(function () {
        //@ts-ignore
        if (!isResponsive && calendarRef.current) {
            //@ts-ignore
            calendarRef.current.getApi().setOption('height', 'auto');
        }
    }, [isResponsive, calendarRef]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FullCalendar
        //@ts-ignore
        , __assign({ 
            //@ts-ignore
            ref: calendarRef }, getFCDesktopOptions({
            isResponsive: isResponsive,
            isCurrentTimeShown: isCurrentTimeShown,
            is24format: is24format,
            timezone: timezone,
            dates: dates,
            isPrivateEventsShown: isPrivateEventsShown,
            locale: locale,
            firstDay: firstDay,
            // recurrenceArr,
            isMobile: isMobile,
        }), { 
            //custom components
            eventContent: function (_a) {
                var event = _a.event;
                return (React.createElement(WeeklyEvent, { event: event, isMobile: false }));
            }, slotLabelContent: function (time) { return (React.createElement(WeeklyLeftSideTime, { time: time, isMobile: false, is24format: is24format, isResponsive: isResponsive })); } })),
        datePickerIsShown && (React.createElement(WeeklyDatePicker, { datePickerRef: datePickerRef, datePickerSelectHandler: datePickerSelectHandler, setDatePickerIsShown: setDatePickerIsShown }))));
};
export default WeeklyCalendarFunc;
//# sourceMappingURL=WeeklyCalendarFunc.js.map